export default __webpack_public_path__ + "static/media/networkTopology.35ba5195.svg";